import { Link } from "react-router-dom";

const NAVY  = "#1A1A2E";
const EMBER = "#FF6B35";

export default function NotFound() {
  return (
    <div
      className="min-h-screen flex flex-col items-center justify-center px-6 text-center"
      style={{ backgroundColor: NAVY }}
    >
      <p
        className="text-8xl md:text-9xl font-bold leading-none mb-6"
        style={{ color: EMBER }}
      >
        404
      </p>

      <h1 className="text-2xl md:text-3xl font-bold text-white mb-3">
        This page doesn't exist — yet.
      </h1>

      <p className="text-gray-400 mb-10 max-w-sm leading-relaxed">
        The link may be broken, or the page may have moved.
      </p>

      <div className="flex flex-col sm:flex-row gap-4">
        <Link
          to="/"
          className="inline-flex items-center justify-center rounded-full px-8 py-3 text-base font-medium text-white whitespace-nowrap transition hover:opacity-90"
          style={{ backgroundColor: EMBER, boxShadow: "0 4px 14px rgba(255,107,53,0.3)" }}
        >
          Go Home
        </Link>
        <Link
          to="/contact"
          className="inline-flex items-center justify-center rounded-full border border-gray-600 px-8 py-3 text-base font-medium text-gray-300 whitespace-nowrap transition hover:border-gray-400 hover:text-white"
        >
          Contact Us
        </Link>
      </div>

      {/* Suggested pages */}
      <div className="mt-12 w-full max-w-sm">
        <p className="text-xs font-semibold uppercase tracking-widest text-gray-600 mb-4">
          You might be looking for
        </p>
        <div className="grid grid-cols-2 gap-2">
          {[
            { to: "/",                label: "Homepage"     },
            { to: "/retailers",       label: "Retailers"    },
            { to: "/how-it-works",    label: "How It Works" },
            { to: "/contact",         label: "Contact"      },
          ].map(({ to, label }) => (
            <Link
              key={to}
              to={to}
              className="rounded-lg border border-gray-800 bg-gray-900/40 px-4 py-3 text-sm text-gray-400 transition hover:border-gray-700 hover:text-white text-left"
            >
              {label} →
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
}
